<template>
  <div>
    <h3 class="field-label">{{ question.label }}</h3>
    <div class="flex field-value">
      {{ hasTermData ?
        (termData.displayName || `Semester ${termData.semester}, ${termData.year}`)
        : '-'
      }}
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: [String, Number, Boolean, Array, Object],
      default: '-',
    },
    question: {
      type: Object,
      required: true,
    },
  },
  inject: {
    terms: {
      default: () => []
    }
  },
  computed: {
    hasTermData() {
      return Object.keys(this.termData).length > 0
    },
    termData() {
      const idValue =
        typeof this.value === 'object' ? this.value.id : this.value
      return (this.terms || []).find((term) => term.id === idValue) || {}
    },
  },
}
</script>
